const LocalStorageKeys = {
  ChatAnnouncementVisible: 'ChatAnnouncementVisible',
  GuestPreviewForAdminMsgHid: 'GuestPreviewForAdminMsgHid'
};

module.exports = LocalStorageKeys;
